























import { Component, Prop } from 'vue-property-decorator';
import { InputPages } from '../../components/organisms/InputPages';
@Component({ components: {} })
export default class PasswordChangeSection extends InputPages {
  @Prop()
  value!: string;

  confirm_pass = '';
  get isOK() {
    return this.model === this.confirm_pass;
  }

  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }
}
